<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile()"
    max-width="750"
    scrollable
  >
    <v-card>
      <toolbar-card-visita
        :opcao_checklist="
          configuracoes.dados.opcoes_checklist.find(
            (oc) => oc.rota == '/nutricao-alimentacao'
          )
        "
      />
      <v-card-text :class="{ 'pb-10': isMobile() }">
        <v-row :dense="isMobile()" class="mt-6">
          <v-col md="6" cols="12">
            <v-text-field
              class="font-weight-medium title"
              label="Quantidade de tratos"
              clearable
              :dense="isMobile()"
              outlined
              v-model="visita.qtd_tratos"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-checkbox
              v-model="visita.tmr"
              class="mt-0"
              label="TMR (Ração Total Misturada)"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-textarea
              outlined
              label="Observações TMR"
              rows="5"
              persistent-placeholder
              placeholder="Ex.: homogeneidade, separação de ingredientes, umidade, sobra no cocho, qualidade da mistura."
              v-model="visita.obs_tmr"
              auto-grow
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-list outlined class="rounded-lg">
              <v-subheader>Checklist Nutricional</v-subheader>
              <template v-for="(opcao, i) in checklist_nutricional">
                <v-list-item :key="i" :to="`${$route.path}${opcao.rota}`">
                  <v-list-item-avatar>
                    <v-icon>{{ opcao.icone }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{
                      opcao.descricao
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  :key="opcao.descricao"
                  v-if="i < checklist_nutricional.length - 1"
                ></v-divider>
              </template>
            </v-list>
          </v-col>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
export default {
  components: {
    ToolbarCardVisita,
    BtnSalvarDadosVisita,
  },
  computed: mapState("visitaTecnica", ["configuracoes", "visita"]),
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,
    checklist_nutricional: [
      { descricao: "Silagem", icone: "mdi-corn", rota: "/silagem" },
      {
        descricao: "Peneiramento Penn State",
        icone: "mdi-filter-variant",
        rota: "/penn-state",
      },
      {
        descricao: "Avaliação das fezes",
        icone: "mdi-clipboard-text-outline",
        rota: "/avaliacao-fezes",
      },
      {
        descricao: "Dieta sugerida",
        icone: "mdi-nutrition",
        rota: "/dieta-sugerida",
      },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>